
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5c1be6e1!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./EditVRWordCloud.vue")
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5c1be6e1&scoped=true!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./EditVRWordCloud.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EditVRWordCloud.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-5c1be6e1!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EditVRWordCloud.vue"),
  /* scopeId */
  "data-v-5c1be6e1",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/liveDiscussion/Modals/EditVRWordCloud.vue
// module id = 1906
// module chunks = 61